import React, { useEffect, useRef } from 'react'
import { COOKIE, getCookie } from '../../../services/cookie';
import ReactHlsPlayer from 'react-hls-player';

function VideoHlsPlayer({ videoDetails, apiUrl}) {
	
	const playerRef = useRef(null);
	const playerConfig = {
		minAutoBitrate: 0,
		hlsConfig: {
			xhrSetup: (xhr) => {
				// Add custom headers
				xhr.setRequestHeader('Authorization', `Bearer ${getCookie(COOKIE.Token)}`);
			}
		}
	};
	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.code === 'Space' || e.code === 'Enter') {
				e.preventDefault();
				const player = playerRef.current;
				if (player) {
					if (player.paused) {
						player.play();
					} else {
						player.pause();
					}
				}
			}
		};

		window.addEventListener('keydown', handleKeyDown);
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, []);
	if (!videoDetails?.filename) return null;
  return (
	  <ReactHlsPlayer
	  	  playerRef={playerRef}
		  src={`${apiUrl}/${videoDetails?.filename}/index.m3u8`}
		  autoPlay={true}
		  controls={true}
		  className=" p-3 mx-auto md:h-[70vh] w-fit"
		  {...playerConfig}
		  onContextMenu={(e) => e.preventDefault()}
		  controlsList='nodownload'
	  />
  )
}

export default VideoHlsPlayer
